import type { QuantClient } from '@thinkalpha/quant-ws-client/client.js';
import { SymbolRecord } from '@thinkalpha/quant-ws-client/contracts/security.js';

const SYMBOL_PAGE_LIMIT = 1_000;
const SECURITY_MASTER_FIELDS = [
    'symbol',
    'name',
    'securityType',
    'exchange',
    'mic',
    'operatingMic',
    'description',
] as const satisfies readonly (keyof SymbolRecord)[];

export async function getAllSymbolRecords(client: Pick<QuantClient, 'getSymbols'>): Promise<SymbolRecord[]> {
    const records: SymbolRecord[] = [];
    let skip = 0;

    while (true) {
        const page = await client.getSymbols({
            fields: [...SECURITY_MASTER_FIELDS],
            limit: SYMBOL_PAGE_LIMIT,
            skip,
        });

        if (page.length === 0) return records;

        records.push(...page.map((record) => SymbolRecord.parse(record)));
        // Advance by what the API actually returned because quant-ws can cap
        // a page below the requested limit.
        skip += page.length;
    }
}
